<template>
  <div v-show="show">
    <h5 class="card-title text-uppercase text-muted mb-0">{{title}}</h5>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "wizard-tab",
  props: {
    title: {
      type: String,
      description: "Wizard step title",
      default: 'Formulário',
    },
    icon: {
      type: String,
      description: "Wizard step title",
      default: '',
    },
  },
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style>

</style>